import { z } from 'zod';

/**
 * Base Schemas
 * Reusable base validation schemas used across the platform
 */

// Common ID Schema (CUID format)
export const IdSchema = z.string().cuid({
  message: "Invalid ID format. Must be a valid CUID."
});

// Email Schema (reusable)
export const EmailSchema = z
  .string()
  .email({ message: "Please enter a valid email address" })
  .max(320, { message: "Email must be less than 320 characters" });

// URL Schema (reusable)
export const UrlSchema = z
  .string()
  .url({ message: "Please enter a valid URL" });

// Date Range Schema
export const DateRangeSchema = z.object({
  startDate: z.coerce.date({
    error: "Start date must be a valid date"
  }),
  
  endDate: z.coerce.date({
    error: "End date must be a valid date"
  })
}).refine(data => data.endDate >= data.startDate, {
  message: "End date must be after start date",
  path: ["endDate"]
});

// Export TypeScript types
export type DateRange = z.infer<typeof DateRangeSchema>;